export const DEFAULT_SCHEDULED_REPORT_TIME = "15:40:00";
